const CHANNEL_NAME = "auth_channel";

class AuthChannelManager {
    constructor() {
        this.channelName = CHANNEL_NAME;
        this.listeners = new Set();
        this.bc = null;

        this.init();
    }

    init() {
        // cek support BroadcastChannel
        if (typeof BroadcastChannel !== "undefined") {
            this.bc = new BroadcastChannel(this.channelName);

            this.bc.onmessage = (event) => {
                this.notify(event.data);
            };
        }

        // fallback localStorage
        window.addEventListener("storage", (e) => {
            if (e.key === this.channelName && e.newValue) {
                try {
                    const data = JSON.parse(e.newValue);
                    this.notify(data);
                } catch (err) {
                    console.error("Invalid storage event", err);
                }
            }
        });
    }

    notify(data) {
        this.listeners.forEach((cb) => {
            try {
                cb(data);
            } catch (err) {
                console.error("Listener error:", err);
            }
        });
    }

    postMessage(data) {
        const payload = {
            ...data,
            time: Date.now(),
        };

        // BroadcastChannel (utama)
        if (this.bc) {
            this.bc.postMessage(payload);
        }

        // fallback localStorage (selalu jalan)
        localStorage.setItem(this.channelName, JSON.stringify(payload));
    }

    subscribe(callback) {
        this.listeners.add(callback);

        return () => {
            this.listeners.delete(callback);
        };
    }

    destroy() {
        this.bc?.close();
        this.listeners.clear();
    }
}

// 🔥 singleton instance
const authChannel = new AuthChannelManager();

export default authChannel;